/**
 * 应收逾期原因枚举（与 bms-common ReceivableOverdueDescSupport 新文案一致）。
 */

/** 未开票原因下拉 */
export const RMS_VAT_OVERDUE_DESC_OPTIONS = [
  { value: '未完全收货', label: '未完全收货' },
  { value: '客户取消/退货', label: '客户取消/退货' },
  { value: '可开票', label: '可开票' },
  { value: '等客户通知开票', label: '等客户通知开票' },
];

/** 未回款原因下拉 */
export const RMS_BACK_OVERDUE_DESC_OPTIONS = [
  { value: '发票丢失', label: '发票丢失' },
  { value: '未挂账-客户无预算', label: '未挂账-客户无预算' },
  { value: '客户已回款未核销', label: '客户已回款未核销' },
  { value: '已挂账-客户无预算', label: '已挂账-客户无预算' },
  { value: '客户取消/退货', label: '客户取消/退货' },
];

/** 未开票原因 value 列表（H5 等） */
export const RMS_VAT_OVERDUE_DESC_VALUES = RMS_VAT_OVERDUE_DESC_OPTIONS.map((o) => o.value);

/** 未回款原因 value 列表（H5 等） */
export const RMS_BACK_OVERDUE_DESC_VALUES = RMS_BACK_OVERDUE_DESC_OPTIONS.map((o) => o.value);

/**
 * 是否为「客户取消/退货」原因（含历史库内文案），用于重复订单、客户证明、提交 OA。
 */
export function isCustomerCancelOrReturnReason(desc) {
  if (!desc) {
    return false;
  }
  const value = String(desc).trim();
  return value === '客户取消/退货'
    || value === '客户取消'
    || value === '退货未核销';
}

/** 提交 OA 不满足条件时的提示 */
export const RMS_OA_CUSTOMER_CANCEL_HINT = '客户取消/退货的订单才能提交OA';
